import type {
  InsightActionCounts,
  InsightActionPreview,
  InsightActionRunStatus,
  RunDetail,
  RunItemView,
} from './insightAction.types'

export type PanelMode = 'read' | 'act' | 'history'
export type ActStep = 'select' | 'confirm' | 'progress' | 'result'

export interface PreviewEntry {
  preview: InsightActionPreview | null
  loading: boolean
  errorCode: string
}

export interface RunState {
  runId: string
  insightId: number
  status: InsightActionRunStatus
  totalItems: number
  counts: InsightActionCounts
  detail: RunDetail | null
  items: RunItemView[]
}

export interface StaleRecovery {
  kept: number
  dropped: number
}

export function previewKey(
  accountId: number | string,
  workspaceId: number | string,
  insightId: number | string,
): string {
  return `${accountId}:${workspaceId}:${insightId}`
}
